import { Component } from '@angular/core';
import { SkeletonBlock } from '../../../../shared/components/skeleton/skeleton-block';

/** Desktop/tablet package-type card count (`skelPackage`). */
const PACKAGE_CARD_PLACEHOLDER_COUNT = 4;

/**
 * Package-step content skeleton.
 * Desktop/tablet: four option rows; mobile: one expanded card matching the 390pt prototype.
 */
@Component({
  selector: 'app-package-selection-skeleton',
  imports: [SkeletonBlock],
  templateUrl: './package-selection-skeleton.html',
  styleUrl: './package-selection-skeleton.scss',
})
export class PackageSelectionSkeleton {
  protected readonly cardPlaceholders = Array.from(
    { length: PACKAGE_CARD_PLACEHOLDER_COUNT },
    (_, index) => index,
  );

  protected readonly helperLineWidths = ['100%', '96%', '92%', '54%'] as const;
}
